export default __webpack_public_path__ + "static/media/oscer-pres-skin-lumps-ulcers.eec8a82c.svg";